// The Cozy and Compact message displays' rows (#141), as they were before bubbles: Discord-style, the avatar in a gutter
// with the name and time above the text (compact: no avatars, the name inline), a day line above the first message of a
// day. Chosen in MessageList's MESSAGE_LAYOUTS. Its CSS is the `:not([data-density="bubbles"])` rules in styles.css and lists.css.
import { Avatar } from "../ui.tsx";
import { MessageTime } from "../MessageTime.tsx";
import { useNameLook } from "../../coloredNames.ts";
import { dayLabel, DAY_PX, type FrameProps, type MessageLayout, type RowItem } from "../MessageLayout.ts";

function ClassicFrame({ it, name, compact, tags, replyRef, children }: FrameProps) {
  const { m, first } = it;
  const look = useNameLook(m.authorId);
  return (
    <>
      {replyRef}
      <div className="msg-row">
        <div className="gutter">
          {first && !compact ? (
            <Avatar id={m.authorId} name={name} size={32} />
          ) : (
            <MessageTime ts={m.ts} short className={`time-hover${first ? " shown" : ""}`} />
          )}
        </div>
        <div style={{ minWidth: 0, flex: 1 }}>
          {first && (
            <div className="who">
              <strong className={look.className} style={look.style}>{name}</strong>
              {tags}
              {!compact && <MessageTime ts={m.ts} />}
            </div>
          )}
          {children}
        </div>
      </div>
    </>
  );
}

export const classicMessages: MessageLayout = {
  id: "classic",
  Stamp: ({ it }: { it: RowItem }) => (it.newDay ? <div className="day">{dayLabel(it.m.ts)}</div> : null),
  rowClass: () => "",
  Frame: ClassicFrame,
  Bubble: ({ children }) => <>{children}</>,
  stampPx: (it) => (it.newDay ? DAY_PX : 0),
  // Compact rows have no name line: the name sits inline with the text.
  headPx: (it, compact) => (it.first ? (compact ? 6 : 30) : 2),
  replyPx: 22,
  textPx: (body, width) => {
    const perLine = Math.max(16, (width - 90) / 7.4);
    return 20 * body.split("\n").reduce((n, line) => n + Math.max(1, Math.ceil(line.length / perLine)), 0);
  },
  key: (it) => `${+it.first}${+it.newDay}`,
};
